export const CONTACT_DELETE_RESET = 'CONTACT_DELETE_RESET'
export const CONTACT_DELETE_SET_ERROR = 'CONTACT_DELETE_SET_ERROR'
export const CONTACT_DELETE_SET_DELETED = 'CONTACT_DELETE_SET_DELETED'
export const CONTACT_DELETE_TOGGLE_LOADING = 'CONTACT_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/contact/delete/mutation_types.js